import React from 'react';
import { Table } from 'react-bootstrap';
import { floatRenderer } from '../../../services/formatSvc';
import {getCurrentStyle} from "../../../helpers/passport";

export default function BudgetTableSf({ status, data, finSource,acceptedData }) {
  const renderRow = (d,index) => {
      const findInSources = (type,element) => finSource.sources[type] && finSource.sources[type]?.find((argument) => argument.id === element);
      const acceptedElement = acceptedData && acceptedData?.[index];
    // const sfSource = finSource.sources.sf.find((sf) => sf.id === d.sfSourceId);
    // const funding = finSource.sources.funding.find((fund) => fund.id === d.fundingId);
      const [sfSource,acceptedSfCode] = [findInSources('sf',d?.sfSourceId),findInSources('sf',acceptedElement?.sfSourceId)];
      const [funding,acceptedFunding] = [findInSources('funding',d?.fundingId),findInSources('funding',acceptedElement?.fundingId)];
    return (
      <tr key={d.id}>
        <td >{d.year}</td>
        <td style={getCurrentStyle(status,sfSource,acceptedSfCode,'name')}>{sfSource.name}</td>
        <td style={getCurrentStyle(status,funding,acceptedFunding,'name')}>{funding && funding.name}</td>
        <td style={getCurrentStyle(status,d,acceptedElement,'sum')}>{floatRenderer(d.sum)}</td>
      </tr>
    );
  };

  return (
    <Table striped className="read-view">
      <thead>
        <tr>
          <th>Год</th>
          <th>Источник</th>
          <th>Тип софинансирования</th>
          <th>План, руб</th>
        </tr>
      </thead>
      <tbody>
        { data.map((el,index)=>renderRow(el,index)) }
      </tbody>
    </Table>
  );
}
